import imgExit from '@assets/web-v3-images/icons/exits.png';
import imgCongratulation from '@assets/web-v3-images/congratulation-popup-1.png';
import Popups from '..';

//UI-4 dùng cho các popup mua turn thành công , đạt mốc hành trình.....
export default function SuccessTurnPopup({
	open,
	onOpenChange,
	children,
	hiddenIconExit = false,
	backgroundImg,
	title = 'Demo'
}) {
	return (
		<Popups
			open={open}
			onOpenChange={onOpenChange}
			className="!bg-transparent !shadow-none !p-0 !max-w-[700px]"
		>
			<div className='relative'>
				<img src={imgCongratulation} className="w-full relative -top-18 sm:-top-[35px] h-auto z-10" />
				<div className="flex flex-col w-full relative -mt-[68%]">
					{!hiddenIconExit &&
						<img src={imgExit} className="w-[10%] h-auto absolute top-[10%] right-10 btn-click-active z-50" onClick={() => onOpenChange(!open)} />
					}
					<div
						className="w-full flex flex-col items-center justify-center text-center min-h-[400px] sm:min-h-[650px] md:min-h-[670px] lg:min-h-[670px] xl:min-h-[670px] relative"
						style={{
							backgroundImage: `url(${backgroundImg})`,
							backgroundPosition: "bottom center",
							backgroundRepeat: 'no-repeat',
							backgroundSize: "100% 100%",
						}}
					>
						<svg width="100%" viewBox="0 0 600 120"
							className='absolute top-[18px] sm:top-[25px] left-1/2 -translate-x-1/2 
											w-full h-[70px] sm:h-[100px] md:h-[120px] lg:h-[120px]'>
							<defs>
								<path
									id="curve"
									d="M 80 90 Q 300 30 520 90"
								/>
							</defs>

							<text
								fontWeight="900"
								fill="#FFFBE8"
								stroke="#C73618"
								strokeWidth="6"
								paintOrder="stroke"
								className='text-[27px]'
							>
								<textPath
									href="#curve"
									startOffset="50%"
									textAnchor="middle"
								>
									{title}
								</textPath>
							</text>
						</svg>
						{children}
					</div>
				</div>
			</div>
		</Popups>
	)
}
